import React from "react";
import styled from "styled-components";

/**
 * Trailing-12-month script-execution bar chart (Monday 12676941123, round 3) — same static-bars
 * house style as the Spotter usage meters (`apps/customer-frontend/.../spotter/usage/UsageScreen.tsx`'s
 * `Spark`/`SparkBar`), swapped in for the earlier hover-sparkline: no hover state, current-month
 * and peak values are printed as plain numbers instead of needing a hover to read them. Linear
 * scale again (not log) — bars already read as relative-height at a glance, so log compression
 * wasn't buying anything once hover-per-point tooltips went away. `domainMax` (the fleet-wide
 * single-month high, passed down from the list screen) keeps every card's bars on the same scale
 * so relative usage across orgs is still comparable card-to-card.
 */

const Bars = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 3px;
  height: 64px;
  width: 100%;
`;

const Bar = styled.i<{ $tone: string; $last?: boolean }>`
  flex: 1;
  min-height: 2px;
  border-radius: 2px 2px 0 0;
  background-color: var(--${(p) => p.$tone}400);
  opacity: ${(p) => (p.$last ? 1 : 0.5)};
`;

const UsageBarChart = (props: {
  values: number[];
  tone: string;
  domainMax: number;
}) => {
  const { values, tone, domainMax } = props;

  if (values.length === 0) {
    return null;
  }

  const max = Math.max(domainMax, ...values, 1);

  return (
    <Bars>
      {values.map((value, index) => (
        <Bar
          key={index}
          $tone={tone}
          $last={index === values.length - 1}
          style={{ height: `${(value / max) * 100}%` }}
        />
      ))}
    </Bars>
  );
};

export default UsageBarChart;
